export const quickPrintPage = () => null;
export const QuickPrintNavLink = () => null;
export const QuickPrintInviteBand = () => null;
